/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Statistics } from '../models/statistics';
import { IncidentStatisticsByHour } from '../models/incident-statistics-by-hour';
import { CustomerApplication } from '../models/customer-application';
import { Camera } from '../models/camera';
import { Site } from '../models/site';
import { PagedResultOfSite } from '../models/paged-result-of-site';
import { PatrolSegment } from '../models/patrol-segment';
import { StatusType } from '../models/status-type';
import { FalsePositiveType } from '../models/false-positive-type';
import { ResponsibleParty } from '../models/responsible-party';
import { Zone } from '../models/zone';
import { Detection } from '../models/detection';
import { Incident } from '../models/incident';
import { Note } from '../models/note';
import { MapLayerItem } from '../models/map-layer-item';
import { IncidentFireSpread } from '../models/incident-fire-spread';
@Injectable({
  providedIn: 'root',
})
class FireForesightService extends __BaseService {
  static readonly FireForesightGetStatisticsPath = '/api/FireForesight/GetStatistics';
  static readonly FireForesightGetIncidentStatisticsByHourPath = '/api/FireForesight/GetIncidentStatisticsByHour';
  static readonly FireForesightGetPath = '/api/FireForesight/Get';
  static readonly FireForesightPurchasePath = '/api/FireForesight/Purchase';
  static readonly FireForesightGetCamerasPath = '/api/FireForesight/GetCameras';
  static readonly FireForesightGetCameraByUriPath = '/api/FireForesight/GetCameraByUri/{customerId}/{siteUri}';
  static readonly FireForesightGetCameraPath = '/api/FireForesight/GetCamera/{customerId}/{siteId}';
  static readonly FireForesightSetDaytimeImagePath = '/api/FireForesight/SetDaytimeImage/{customerId}/{siteId}/{cameraBearing}';
  static readonly FireForesightGetSitePath = '/api/FireForesight/GetSite/{siteId}';
  static readonly FireForesightGetSitesPath = '/api/FireForesight/GetSites';
  static readonly FireForesightCreateSitePath = '/api/FireForesight/Site';
  static readonly FireForesightUpdateSitePath = '/api/FireForesight/Site/{id}';
  static readonly FireForesightGetStreamKeyPath = '/api/FireForesight/GetStreamKey/{customerId}/{siteId}';
  static readonly FireForesightGetSecureStreamPath = '/api/FireForesight/GetSecureStream/{streamKey}';
  static readonly FireForesightGetStatusTypesPath = '/api/FireForesight/GetStatusTypes';
  static readonly FireForesightAddStatusPath = '/api/FireForesight/AddStatus';
  static readonly FireForesightUpdateStatusPath = '/api/FireForesight/UpdateStatus';
  static readonly FireForesightRemoveStatusPath = '/api/FireForesight/RemoveStatus';
  static readonly FireForesightGetFalsePositiveTypesPath = '/api/FireForesight/GetFalsePositiveTypes';
  static readonly FireForesightGetResponsiblePartiesPath = '/api/FireForesight/GetResponsibleParties';
  static readonly FireForesightAddResponsiblePartyPath = '/api/FireForesight/AddResponsibleParty';
  static readonly FireForesightUpdateResponsiblePartyPath = '/api/FireForesight/UpdateResponsibleParty';
  static readonly FireForesightRemoveResponsiblePartyPath = '/api/FireForesight/RemoveResponsibleParty';
  static readonly FireForesightGetIgnoreZonesPath = '/api/FireForesight/GetIgnoreZones/{customerId}/{siteUri}';
  static readonly FireForesightCreateIgnoreZonePath = '/api/FireForesight/CreateIgnoreZone';
  static readonly FireForesightUpdateIgnoreZonePath = '/api/FireForesight/UpdateIgnoreZone';
  static readonly FireForesightDeleteIgnoreZonePath = '/api/FireForesight/DeleteIgnoreZone';
  static readonly FireForesightRaiseManualDetectionPath = '/api/FireForesight/RaiseManualDetection';
  static readonly FireForesightGetIncidentsPath = '/api/FireForesight/GetIncidents/{customerId}/{statusId}/{siteUri}';
  static readonly FireForesightGetIncidentPath = '/api/FireForesight/GetIncident/{customerId}/{incidentId}';
  static readonly FireForesightUpdateDetectionMetaDataPath = '/api/FireForesight/UpdateDetectionMetaData';
  static readonly FireForesightMergeIncidentsPath = '/api/FireForesight/MergeIncidents';
  static readonly FireForesightUpdateIncidentPath = '/api/FireForesight/UpdateIncident';
  static readonly FireForesightSetInitialFireLocationPath = '/api/FireForesight/SetInitialFireLocation';
  static readonly FireForesightAddNotePath = '/api/FireForesight/AddNote';
  static readonly FireForesightRemoveNotePath = '/api/FireForesight/RemoveNote';
  static readonly FireForesightGetMapLayersPath = '/api/FireForesight/GetMapLayers';
  static readonly FireForesightGetLastestFireSpreadModelPath = '/api/FireForesight/GetLastestFireSpreadModel/{customerId}/{incidentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  FireForesightGetStatisticsResponse(customerId?: number): __Observable<__StrictHttpResponse<Statistics>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetStatistics`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Statistics>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightGetStatistics(customerId?: number): __Observable<Statistics> {
    return this.FireForesightGetStatisticsResponse(customerId).pipe(
      __map(_r => _r.body as Statistics)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetIncidentStatisticsByHourParams` containing the following parameters:
   *
   * - `timeZoneId`:
   *
   * - `start`:
   *
   * - `end`:
   *
   * - `customerId`:
   */
  FireForesightGetIncidentStatisticsByHourResponse(params: FireForesightService.FireForesightGetIncidentStatisticsByHourParams): __Observable<__StrictHttpResponse<Array<IncidentStatisticsByHour>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.timeZoneId != null) __params = __params.set('timeZoneId', params.timeZoneId.toString());
    if (params.start != null) __params = __params.set('start', params.start.toString());
    if (params.end != null) __params = __params.set('end', params.end.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetIncidentStatisticsByHour`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<IncidentStatisticsByHour>>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetIncidentStatisticsByHourParams` containing the following parameters:
   *
   * - `timeZoneId`:
   *
   * - `start`:
   *
   * - `end`:
   *
   * - `customerId`:
   */
  FireForesightGetIncidentStatisticsByHour(params: FireForesightService.FireForesightGetIncidentStatisticsByHourParams): __Observable<Array<IncidentStatisticsByHour>> {
    return this.FireForesightGetIncidentStatisticsByHourResponse(params).pipe(
      __map(_r => _r.body as Array<IncidentStatisticsByHour>)
    );
  }

  /**
   * @param customerId undefined
   */
  FireForesightGetResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/Get`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightGet(customerId?: number): __Observable<CustomerApplication> {
    return this.FireForesightGetResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param customerId undefined
   */
  FireForesightPurchaseResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/Purchase`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightPurchase(customerId?: number): __Observable<CustomerApplication> {
    return this.FireForesightPurchaseResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param customerId undefined
   */
  FireForesightGetCamerasResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<Camera>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetCameras`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Camera>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightGetCameras(customerId?: number): __Observable<Array<Camera>> {
    return this.FireForesightGetCamerasResponse(customerId).pipe(
      __map(_r => _r.body as Array<Camera>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetCameraByUriParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetCameraByUriResponse(params: FireForesightService.FireForesightGetCameraByUriParams): __Observable<__StrictHttpResponse<Camera>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetCameraByUri/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteUri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Camera>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetCameraByUriParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetCameraByUri(params: FireForesightService.FireForesightGetCameraByUriParams): __Observable<Camera> {
    return this.FireForesightGetCameraByUriResponse(params).pipe(
      __map(_r => _r.body as Camera)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   */
  FireForesightGetCameraResponse(params: FireForesightService.FireForesightGetCameraParams): __Observable<__StrictHttpResponse<Camera>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetCamera/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Camera>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   */
  FireForesightGetCamera(params: FireForesightService.FireForesightGetCameraParams): __Observable<Camera> {
    return this.FireForesightGetCameraResponse(params).pipe(
      __map(_r => _r.body as Camera)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightSetDaytimeImageParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   *
   * - `cameraBearing`:
   *
   * - `url`:
   */
  FireForesightSetDaytimeImageResponse(params: FireForesightService.FireForesightSetDaytimeImageParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    if (params.url != null) __params = __params.set('url', params.url.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/SetDaytimeImage/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteId))}/${encodeURIComponent(String(params.cameraBearing))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightSetDaytimeImageParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   *
   * - `cameraBearing`:
   *
   * - `url`:
   */
  FireForesightSetDaytimeImage(params: FireForesightService.FireForesightSetDaytimeImageParams): __Observable<boolean> {
    return this.FireForesightSetDaytimeImageResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param siteId undefined
   */
  FireForesightGetSiteResponse(siteId: number): __Observable<__StrictHttpResponse<Site>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetSite/${encodeURIComponent(String(siteId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Site>;
      })
    );
  }
  /**
   * @param siteId undefined
   */
  FireForesightGetSite(siteId: number): __Observable<Site> {
    return this.FireForesightGetSiteResponse(siteId).pipe(
      __map(_r => _r.body as Site)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetSitesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `page`:
   */
  FireForesightGetSitesResponse(params: FireForesightService.FireForesightGetSitesParams): __Observable<__StrictHttpResponse<PagedResultOfSite>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetSites`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PagedResultOfSite>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetSitesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `page`:
   */
  FireForesightGetSites(params: FireForesightService.FireForesightGetSitesParams): __Observable<PagedResultOfSite> {
    return this.FireForesightGetSitesResponse(params).pipe(
      __map(_r => _r.body as PagedResultOfSite)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightCreateSiteParams` containing the following parameters:
   *
   * - `YawError`:
   *
   * - `StorageBaseUrl`:
   *
   * - `SiteUri`:
   *
   * - `SiteId`:
   *
   * - `RollError`:
   *
   * - `PitchError`:
   *
   * - `PatrolSegments`:
   *
   * - `NextScheduledPatrol`:
   *
   * - `Name`:
   *
   * - `Longitude`:
   *
   * - `Latitude`:
   *
   * - `ImageWidth`:
   *
   * - `ImageHeight`:
   *
   * - `FieldOfView`:
   *
   * - `DemUrl`:
   *
   * - `CustomerId`:
   *
   * - `CameraHeight`:
   *
   * - `CameraElevation`:
   *
   * - `CameraAltitude`:
   */
  FireForesightCreateSiteResponse(params: FireForesightService.FireForesightCreateSiteParams): __Observable<__StrictHttpResponse<Site>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.YawError != null) __params = __params.set('YawError', params.YawError.toString());
    if (params.StorageBaseUrl != null) __params = __params.set('StorageBaseUrl', params.StorageBaseUrl.toString());
    if (params.SiteUri != null) __params = __params.set('SiteUri', params.SiteUri.toString());
    if (params.SiteId != null) __params = __params.set('SiteId', params.SiteId.toString());
    if (params.RollError != null) __params = __params.set('RollError', params.RollError.toString());
    if (params.PitchError != null) __params = __params.set('PitchError', params.PitchError.toString());
    (params.PatrolSegments || []).forEach(val => {if (val != null) __params = __params.append('PatrolSegments', val.toString())});
    if (params.NextScheduledPatrol != null) __params = __params.set('NextScheduledPatrol', params.NextScheduledPatrol.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Longitude != null) __params = __params.set('Longitude', params.Longitude.toString());
    if (params.Latitude != null) __params = __params.set('Latitude', params.Latitude.toString());
    if (params.ImageWidth != null) __params = __params.set('ImageWidth', params.ImageWidth.toString());
    if (params.ImageHeight != null) __params = __params.set('ImageHeight', params.ImageHeight.toString());
    if (params.FieldOfView != null) __params = __params.set('FieldOfView', params.FieldOfView.toString());
    if (params.DemUrl != null) __params = __params.set('DemUrl', params.DemUrl.toString());
    if (params.CustomerId != null) __params = __params.set('CustomerId', params.CustomerId.toString());
    if (params.CameraHeight != null) __params = __params.set('CameraHeight', params.CameraHeight.toString());
    if (params.CameraElevation != null) __params = __params.set('CameraElevation', params.CameraElevation.toString());
    if (params.CameraAltitude != null) __params = __params.set('CameraAltitude', params.CameraAltitude.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/Site`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Site>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightCreateSiteParams` containing the following parameters:
   *
   * - `YawError`:
   *
   * - `StorageBaseUrl`:
   *
   * - `SiteUri`:
   *
   * - `SiteId`:
   *
   * - `RollError`:
   *
   * - `PitchError`:
   *
   * - `PatrolSegments`:
   *
   * - `NextScheduledPatrol`:
   *
   * - `Name`:
   *
   * - `Longitude`:
   *
   * - `Latitude`:
   *
   * - `ImageWidth`:
   *
   * - `ImageHeight`:
   *
   * - `FieldOfView`:
   *
   * - `DemUrl`:
   *
   * - `CustomerId`:
   *
   * - `CameraHeight`:
   *
   * - `CameraElevation`:
   *
   * - `CameraAltitude`:
   */
  FireForesightCreateSite(params: FireForesightService.FireForesightCreateSiteParams): __Observable<Site> {
    return this.FireForesightCreateSiteResponse(params).pipe(
      __map(_r => _r.body as Site)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightUpdateSiteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `YawError`:
   *
   * - `StorageBaseUrl`:
   *
   * - `SiteUri`:
   *
   * - `SiteId`:
   *
   * - `RollError`:
   *
   * - `PitchError`:
   *
   * - `PatrolSegments`:
   *
   * - `NextScheduledPatrol`:
   *
   * - `Name`:
   *
   * - `Longitude`:
   *
   * - `Latitude`:
   *
   * - `ImageWidth`:
   *
   * - `ImageHeight`:
   *
   * - `FieldOfView`:
   *
   * - `DemUrl`:
   *
   * - `CustomerId`:
   *
   * - `CameraHeight`:
   *
   * - `CameraElevation`:
   *
   * - `CameraAltitude`:
   */
  FireForesightUpdateSiteResponse(params: FireForesightService.FireForesightUpdateSiteParams): __Observable<__StrictHttpResponse<Site>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.YawError != null) __params = __params.set('YawError', params.YawError.toString());
    if (params.StorageBaseUrl != null) __params = __params.set('StorageBaseUrl', params.StorageBaseUrl.toString());
    if (params.SiteUri != null) __params = __params.set('SiteUri', params.SiteUri.toString());
    if (params.SiteId != null) __params = __params.set('SiteId', params.SiteId.toString());
    if (params.RollError != null) __params = __params.set('RollError', params.RollError.toString());
    if (params.PitchError != null) __params = __params.set('PitchError', params.PitchError.toString());
    (params.PatrolSegments || []).forEach(val => {if (val != null) __params = __params.append('PatrolSegments', val.toString())});
    if (params.NextScheduledPatrol != null) __params = __params.set('NextScheduledPatrol', params.NextScheduledPatrol.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Longitude != null) __params = __params.set('Longitude', params.Longitude.toString());
    if (params.Latitude != null) __params = __params.set('Latitude', params.Latitude.toString());
    if (params.ImageWidth != null) __params = __params.set('ImageWidth', params.ImageWidth.toString());
    if (params.ImageHeight != null) __params = __params.set('ImageHeight', params.ImageHeight.toString());
    if (params.FieldOfView != null) __params = __params.set('FieldOfView', params.FieldOfView.toString());
    if (params.DemUrl != null) __params = __params.set('DemUrl', params.DemUrl.toString());
    if (params.CustomerId != null) __params = __params.set('CustomerId', params.CustomerId.toString());
    if (params.CameraHeight != null) __params = __params.set('CameraHeight', params.CameraHeight.toString());
    if (params.CameraElevation != null) __params = __params.set('CameraElevation', params.CameraElevation.toString());
    if (params.CameraAltitude != null) __params = __params.set('CameraAltitude', params.CameraAltitude.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/FireForesight/Site/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Site>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightUpdateSiteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `YawError`:
   *
   * - `StorageBaseUrl`:
   *
   * - `SiteUri`:
   *
   * - `SiteId`:
   *
   * - `RollError`:
   *
   * - `PitchError`:
   *
   * - `PatrolSegments`:
   *
   * - `NextScheduledPatrol`:
   *
   * - `Name`:
   *
   * - `Longitude`:
   *
   * - `Latitude`:
   *
   * - `ImageWidth`:
   *
   * - `ImageHeight`:
   *
   * - `FieldOfView`:
   *
   * - `DemUrl`:
   *
   * - `CustomerId`:
   *
   * - `CameraHeight`:
   *
   * - `CameraElevation`:
   *
   * - `CameraAltitude`:
   */
  FireForesightUpdateSite(params: FireForesightService.FireForesightUpdateSiteParams): __Observable<Site> {
    return this.FireForesightUpdateSiteResponse(params).pipe(
      __map(_r => _r.body as Site)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetStreamKeyParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   */
  FireForesightGetStreamKeyResponse(params: FireForesightService.FireForesightGetStreamKeyParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetStreamKey/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetStreamKeyParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   */
  FireForesightGetStreamKey(params: FireForesightService.FireForesightGetStreamKeyParams): __Observable<string> {
    return this.FireForesightGetStreamKeyResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param streamKey undefined
   */
  FireForesightGetSecureStreamResponse(streamKey: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetSecureStream/${encodeURIComponent(String(streamKey))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param streamKey undefined
   */
  FireForesightGetSecureStream(streamKey: string): __Observable<Blob> {
    return this.FireForesightGetSecureStreamResponse(streamKey).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  FireForesightGetStatusTypesResponse(): __Observable<__StrictHttpResponse<Array<StatusType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetStatusTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StatusType>>;
      })
    );
  }  FireForesightGetStatusTypes(): __Observable<Array<StatusType>> {
    return this.FireForesightGetStatusTypesResponse().pipe(
      __map(_r => _r.body as Array<StatusType>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightAddStatusParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `StatusId`:
   *
   * - `OrderBy`:
   *
   * - `IsActiveState`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `Colour`:
   */
  FireForesightAddStatusResponse(params: FireForesightService.FireForesightAddStatusParams): __Observable<__StrictHttpResponse<StatusType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Visible != null) __params = __params.set('Visible', params.Visible.toString());
    if (params.StatusId != null) __params = __params.set('StatusId', params.StatusId.toString());
    if (params.OrderBy != null) __params = __params.set('OrderBy', params.OrderBy.toString());
    if (params.IsActiveState != null) __params = __params.set('IsActiveState', params.IsActiveState.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.Colour != null) __params = __params.set('Colour', params.Colour.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/AddStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StatusType>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightAddStatusParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `StatusId`:
   *
   * - `OrderBy`:
   *
   * - `IsActiveState`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `Colour`:
   */
  FireForesightAddStatus(params: FireForesightService.FireForesightAddStatusParams): __Observable<StatusType> {
    return this.FireForesightAddStatusResponse(params).pipe(
      __map(_r => _r.body as StatusType)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightUpdateStatusParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `StatusId`:
   *
   * - `OrderBy`:
   *
   * - `IsActiveState`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `Colour`:
   */
  FireForesightUpdateStatusResponse(params: FireForesightService.FireForesightUpdateStatusParams): __Observable<__StrictHttpResponse<StatusType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Visible != null) __params = __params.set('Visible', params.Visible.toString());
    if (params.StatusId != null) __params = __params.set('StatusId', params.StatusId.toString());
    if (params.OrderBy != null) __params = __params.set('OrderBy', params.OrderBy.toString());
    if (params.IsActiveState != null) __params = __params.set('IsActiveState', params.IsActiveState.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.Colour != null) __params = __params.set('Colour', params.Colour.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/UpdateStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StatusType>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightUpdateStatusParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `StatusId`:
   *
   * - `OrderBy`:
   *
   * - `IsActiveState`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `Colour`:
   */
  FireForesightUpdateStatus(params: FireForesightService.FireForesightUpdateStatusParams): __Observable<StatusType> {
    return this.FireForesightUpdateStatusResponse(params).pipe(
      __map(_r => _r.body as StatusType)
    );
  }

  /**
   * @param statusId undefined
   */
  FireForesightRemoveStatusResponse(statusId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (statusId != null) __params = __params.set('statusId', statusId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/FireForesight/RemoveStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param statusId undefined
   */
  FireForesightRemoveStatus(statusId?: number): __Observable<Blob> {
    return this.FireForesightRemoveStatusResponse(statusId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  FireForesightGetFalsePositiveTypesResponse(): __Observable<__StrictHttpResponse<Array<FalsePositiveType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetFalsePositiveTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FalsePositiveType>>;
      })
    );
  }  FireForesightGetFalsePositiveTypes(): __Observable<Array<FalsePositiveType>> {
    return this.FireForesightGetFalsePositiveTypesResponse().pipe(
      __map(_r => _r.body as Array<FalsePositiveType>)
    );
  }

  /**
   * @param customerId undefined
   */
  FireForesightGetResponsiblePartiesResponse(customerId?: null | number): __Observable<__StrictHttpResponse<Array<ResponsibleParty>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetResponsibleParties`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponsibleParty>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightGetResponsibleParties(customerId?: null | number): __Observable<Array<ResponsibleParty>> {
    return this.FireForesightGetResponsiblePartiesResponse(customerId).pipe(
      __map(_r => _r.body as Array<ResponsibleParty>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightAddResponsiblePartyParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `ResponsiblePartyId`:
   *
   * - `OrderBy`:
   *
   * - `IsActive`:
   *
   * - `DistributionTemplateId`:
   *
   * - `DistributionListId`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `Colour`:
   */
  FireForesightAddResponsiblePartyResponse(params: FireForesightService.FireForesightAddResponsiblePartyParams): __Observable<__StrictHttpResponse<ResponsibleParty>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Visible != null) __params = __params.set('Visible', params.Visible.toString());
    if (params.ResponsiblePartyId != null) __params = __params.set('ResponsiblePartyId', params.ResponsiblePartyId.toString());
    if (params.OrderBy != null) __params = __params.set('OrderBy', params.OrderBy.toString());
    if (params.IsActive != null) __params = __params.set('IsActive', params.IsActive.toString());
    if (params.DistributionTemplateId != null) __params = __params.set('DistributionTemplateId', params.DistributionTemplateId.toString());
    if (params.DistributionListId != null) __params = __params.set('DistributionListId', params.DistributionListId.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.CustomerId != null) __params = __params.set('CustomerId', params.CustomerId.toString());
    if (params.Colour != null) __params = __params.set('Colour', params.Colour.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/AddResponsibleParty`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponsibleParty>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightAddResponsiblePartyParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `ResponsiblePartyId`:
   *
   * - `OrderBy`:
   *
   * - `IsActive`:
   *
   * - `DistributionTemplateId`:
   *
   * - `DistributionListId`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `Colour`:
   */
  FireForesightAddResponsibleParty(params: FireForesightService.FireForesightAddResponsiblePartyParams): __Observable<ResponsibleParty> {
    return this.FireForesightAddResponsiblePartyResponse(params).pipe(
      __map(_r => _r.body as ResponsibleParty)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightUpdateResponsiblePartyParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `ResponsiblePartyId`:
   *
   * - `OrderBy`:
   *
   * - `IsActive`:
   *
   * - `DistributionTemplateId`:
   *
   * - `DistributionListId`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `Colour`:
   */
  FireForesightUpdateResponsiblePartyResponse(params: FireForesightService.FireForesightUpdateResponsiblePartyParams): __Observable<__StrictHttpResponse<ResponsibleParty>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Visible != null) __params = __params.set('Visible', params.Visible.toString());
    if (params.ResponsiblePartyId != null) __params = __params.set('ResponsiblePartyId', params.ResponsiblePartyId.toString());
    if (params.OrderBy != null) __params = __params.set('OrderBy', params.OrderBy.toString());
    if (params.IsActive != null) __params = __params.set('IsActive', params.IsActive.toString());
    if (params.DistributionTemplateId != null) __params = __params.set('DistributionTemplateId', params.DistributionTemplateId.toString());
    if (params.DistributionListId != null) __params = __params.set('DistributionListId', params.DistributionListId.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.CustomerId != null) __params = __params.set('CustomerId', params.CustomerId.toString());
    if (params.Colour != null) __params = __params.set('Colour', params.Colour.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/UpdateResponsibleParty`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponsibleParty>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightUpdateResponsiblePartyParams` containing the following parameters:
   *
   * - `Visible`:
   *
   * - `ResponsiblePartyId`:
   *
   * - `OrderBy`:
   *
   * - `IsActive`:
   *
   * - `DistributionTemplateId`:
   *
   * - `DistributionListId`:
   *
   * - `DisplayName`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `Colour`:
   */
  FireForesightUpdateResponsibleParty(params: FireForesightService.FireForesightUpdateResponsiblePartyParams): __Observable<ResponsibleParty> {
    return this.FireForesightUpdateResponsiblePartyResponse(params).pipe(
      __map(_r => _r.body as ResponsibleParty)
    );
  }

  /**
   * @param responsiblePartyId undefined
   */
  FireForesightRemoveResponsiblePartyResponse(responsiblePartyId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (responsiblePartyId != null) __params = __params.set('responsiblePartyId', responsiblePartyId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/FireForesight/RemoveResponsibleParty`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param responsiblePartyId undefined
   */
  FireForesightRemoveResponsibleParty(responsiblePartyId?: number): __Observable<Blob> {
    return this.FireForesightRemoveResponsiblePartyResponse(responsiblePartyId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetIgnoreZonesParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetIgnoreZonesResponse(params: FireForesightService.FireForesightGetIgnoreZonesParams): __Observable<__StrictHttpResponse<Array<Zone>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetIgnoreZones/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteUri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Zone>>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetIgnoreZonesParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetIgnoreZones(params: FireForesightService.FireForesightGetIgnoreZonesParams): __Observable<Array<Zone>> {
    return this.FireForesightGetIgnoreZonesResponse(params).pipe(
      __map(_r => _r.body as Array<Zone>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightCreateIgnoreZoneParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightCreateIgnoreZoneResponse(params: FireForesightService.FireForesightCreateIgnoreZoneParams): __Observable<__StrictHttpResponse<Detection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ZoomImageUrl != null) __params = __params.set('ZoomImageUrl', params.ZoomImageUrl.toString());
    if (params.Width != null) __params = __params.set('Width', params.Width.toString());
    if (params.SiteUri != null) __params = __params.set('SiteUri', params.SiteUri.toString());
    if (params.SiteName != null) __params = __params.set('SiteName', params.SiteName.toString());
    if (params.LowerElevation != null) __params = __params.set('LowerElevation', params.LowerElevation.toString());
    if (params.IsUnconfirmed != null) __params = __params.set('IsUnconfirmed', params.IsUnconfirmed.toString());
    if (params.IsNewIncident != null) __params = __params.set('IsNewIncident', params.IsNewIncident.toString());
    if (params.IncidentId != null) __params = __params.set('IncidentId', params.IncidentId.toString());
    if (params.ImageWidth != null) __params = __params.set('ImageWidth', params.ImageWidth.toString());
    if (params.ImageUrl != null) __params = __params.set('ImageUrl', params.ImageUrl.toString());
    if (params.ImageHeight != null) __params = __params.set('ImageHeight', params.ImageHeight.toString());
    if (params.ImageFeedUri != null) __params = __params.set('ImageFeedUri', params.ImageFeedUri.toString());
    if (params.Height != null) __params = __params.set('Height', params.Height.toString());
    if (params.FirstDetected != null) __params = __params.set('FirstDetected', params.FirstDetected.toString());
    if (params.FireDetectionId != null) __params = __params.set('FireDetectionId', params.FireDetectionId.toString());
    if (params.Elevation != null) __params = __params.set('Elevation', params.Elevation.toString());
    if (params.DetectionMetaData != null) __params = __params.set('DetectionMetaData', params.DetectionMetaData.toString());
    if (params.Confidence != null) __params = __params.set('Confidence', params.Confidence.toString());
    if (params.CameraFieldOfView != null) __params = __params.set('CameraFieldOfView', params.CameraFieldOfView.toString());
    if (params.CameraElevation != null) __params = __params.set('CameraElevation', params.CameraElevation.toString());
    if (params.CameraBearing != null) __params = __params.set('CameraBearing', params.CameraBearing.toString());
    if (params.Bearing != null) __params = __params.set('Bearing', params.Bearing.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/CreateIgnoreZone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Detection>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightCreateIgnoreZoneParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightCreateIgnoreZone(params: FireForesightService.FireForesightCreateIgnoreZoneParams): __Observable<Detection> {
    return this.FireForesightCreateIgnoreZoneResponse(params).pipe(
      __map(_r => _r.body as Detection)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightUpdateIgnoreZoneParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightUpdateIgnoreZoneResponse(params: FireForesightService.FireForesightUpdateIgnoreZoneParams): __Observable<__StrictHttpResponse<Detection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ZoomImageUrl != null) __params = __params.set('ZoomImageUrl', params.ZoomImageUrl.toString());
    if (params.Width != null) __params = __params.set('Width', params.Width.toString());
    if (params.SiteUri != null) __params = __params.set('SiteUri', params.SiteUri.toString());
    if (params.SiteName != null) __params = __params.set('SiteName', params.SiteName.toString());
    if (params.LowerElevation != null) __params = __params.set('LowerElevation', params.LowerElevation.toString());
    if (params.IsUnconfirmed != null) __params = __params.set('IsUnconfirmed', params.IsUnconfirmed.toString());
    if (params.IsNewIncident != null) __params = __params.set('IsNewIncident', params.IsNewIncident.toString());
    if (params.IncidentId != null) __params = __params.set('IncidentId', params.IncidentId.toString());
    if (params.ImageWidth != null) __params = __params.set('ImageWidth', params.ImageWidth.toString());
    if (params.ImageUrl != null) __params = __params.set('ImageUrl', params.ImageUrl.toString());
    if (params.ImageHeight != null) __params = __params.set('ImageHeight', params.ImageHeight.toString());
    if (params.ImageFeedUri != null) __params = __params.set('ImageFeedUri', params.ImageFeedUri.toString());
    if (params.Height != null) __params = __params.set('Height', params.Height.toString());
    if (params.FirstDetected != null) __params = __params.set('FirstDetected', params.FirstDetected.toString());
    if (params.FireDetectionId != null) __params = __params.set('FireDetectionId', params.FireDetectionId.toString());
    if (params.Elevation != null) __params = __params.set('Elevation', params.Elevation.toString());
    if (params.DetectionMetaData != null) __params = __params.set('DetectionMetaData', params.DetectionMetaData.toString());
    if (params.Confidence != null) __params = __params.set('Confidence', params.Confidence.toString());
    if (params.CameraFieldOfView != null) __params = __params.set('CameraFieldOfView', params.CameraFieldOfView.toString());
    if (params.CameraElevation != null) __params = __params.set('CameraElevation', params.CameraElevation.toString());
    if (params.CameraBearing != null) __params = __params.set('CameraBearing', params.CameraBearing.toString());
    if (params.Bearing != null) __params = __params.set('Bearing', params.Bearing.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/UpdateIgnoreZone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Detection>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightUpdateIgnoreZoneParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightUpdateIgnoreZone(params: FireForesightService.FireForesightUpdateIgnoreZoneParams): __Observable<Detection> {
    return this.FireForesightUpdateIgnoreZoneResponse(params).pipe(
      __map(_r => _r.body as Detection)
    );
  }

  /**
   * @param id undefined
   */
  FireForesightDeleteIgnoreZoneResponse(id?: number): __Observable<__StrictHttpResponse<Detection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/FireForesight/DeleteIgnoreZone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Detection>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FireForesightDeleteIgnoreZone(id?: number): __Observable<Detection> {
    return this.FireForesightDeleteIgnoreZoneResponse(id).pipe(
      __map(_r => _r.body as Detection)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightRaiseManualDetectionParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightRaiseManualDetectionResponse(params: FireForesightService.FireForesightRaiseManualDetectionParams): __Observable<__StrictHttpResponse<Detection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ZoomImageUrl != null) __params = __params.set('ZoomImageUrl', params.ZoomImageUrl.toString());
    if (params.Width != null) __params = __params.set('Width', params.Width.toString());
    if (params.SiteUri != null) __params = __params.set('SiteUri', params.SiteUri.toString());
    if (params.SiteName != null) __params = __params.set('SiteName', params.SiteName.toString());
    if (params.LowerElevation != null) __params = __params.set('LowerElevation', params.LowerElevation.toString());
    if (params.IsUnconfirmed != null) __params = __params.set('IsUnconfirmed', params.IsUnconfirmed.toString());
    if (params.IsNewIncident != null) __params = __params.set('IsNewIncident', params.IsNewIncident.toString());
    if (params.IncidentId != null) __params = __params.set('IncidentId', params.IncidentId.toString());
    if (params.ImageWidth != null) __params = __params.set('ImageWidth', params.ImageWidth.toString());
    if (params.ImageUrl != null) __params = __params.set('ImageUrl', params.ImageUrl.toString());
    if (params.ImageHeight != null) __params = __params.set('ImageHeight', params.ImageHeight.toString());
    if (params.ImageFeedUri != null) __params = __params.set('ImageFeedUri', params.ImageFeedUri.toString());
    if (params.Height != null) __params = __params.set('Height', params.Height.toString());
    if (params.FirstDetected != null) __params = __params.set('FirstDetected', params.FirstDetected.toString());
    if (params.FireDetectionId != null) __params = __params.set('FireDetectionId', params.FireDetectionId.toString());
    if (params.Elevation != null) __params = __params.set('Elevation', params.Elevation.toString());
    if (params.DetectionMetaData != null) __params = __params.set('DetectionMetaData', params.DetectionMetaData.toString());
    if (params.Confidence != null) __params = __params.set('Confidence', params.Confidence.toString());
    if (params.CameraFieldOfView != null) __params = __params.set('CameraFieldOfView', params.CameraFieldOfView.toString());
    if (params.CameraElevation != null) __params = __params.set('CameraElevation', params.CameraElevation.toString());
    if (params.CameraBearing != null) __params = __params.set('CameraBearing', params.CameraBearing.toString());
    if (params.Bearing != null) __params = __params.set('Bearing', params.Bearing.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/FireForesight/RaiseManualDetection`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Detection>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightRaiseManualDetectionParams` containing the following parameters:
   *
   * - `ZoomImageUrl`:
   *
   * - `Width`:
   *
   * - `SiteUri`:
   *
   * - `SiteName`:
   *
   * - `LowerElevation`:
   *
   * - `IsUnconfirmed`:
   *
   * - `IsNewIncident`:
   *
   * - `IncidentId`:
   *
   * - `ImageWidth`:
   *
   * - `ImageUrl`:
   *
   * - `ImageHeight`:
   *
   * - `ImageFeedUri`:
   *
   * - `Height`:
   *
   * - `FirstDetected`:
   *
   * - `FireDetectionId`:
   *
   * - `Elevation`:
   *
   * - `DetectionMetaData`:
   *
   * - `Confidence`:
   *
   * - `CameraFieldOfView`:
   *
   * - `CameraElevation`:
   *
   * - `CameraBearing`:
   *
   * - `Bearing`:
   */
  FireForesightRaiseManualDetection(params: FireForesightService.FireForesightRaiseManualDetectionParams): __Observable<Detection> {
    return this.FireForesightRaiseManualDetectionResponse(params).pipe(
      __map(_r => _r.body as Detection)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetIncidentsParams` containing the following parameters:
   *
   * - `statusId`:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetIncidentsResponse(params: FireForesightService.FireForesightGetIncidentsParams): __Observable<__StrictHttpResponse<Array<Incident>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetIncidents/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.statusId))}/${encodeURIComponent(String(params.siteUri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Incident>>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetIncidentsParams` containing the following parameters:
   *
   * - `statusId`:
   *
   * - `siteUri`:
   *
   * - `customerId`:
   */
  FireForesightGetIncidents(params: FireForesightService.FireForesightGetIncidentsParams): __Observable<Array<Incident>> {
    return this.FireForesightGetIncidentsResponse(params).pipe(
      __map(_r => _r.body as Array<Incident>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetIncidentParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `customerId`:
   */
  FireForesightGetIncidentResponse(params: FireForesightService.FireForesightGetIncidentParams): __Observable<__StrictHttpResponse<Incident>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetIncident/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.incidentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Incident>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetIncidentParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `customerId`:
   */
  FireForesightGetIncident(params: FireForesightService.FireForesightGetIncidentParams): __Observable<Incident> {
    return this.FireForesightGetIncidentResponse(params).pipe(
      __map(_r => _r.body as Incident)
    );
  }

  /**
   * @param detection undefined
   */
  FireForesightUpdateDetectionMetaDataResponse(detection: Detection): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = detection;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/UpdateDetectionMetaData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param detection undefined
   */
  FireForesightUpdateDetectionMetaData(detection: Detection): __Observable<Blob> {
    return this.FireForesightUpdateDetectionMetaDataResponse(detection).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightMergeIncidentsParams` containing the following parameters:
   *
   * - `secondaryIncidentId`:
   *
   * - `primaryIncidentId`:
   */
  FireForesightMergeIncidentsResponse(params: FireForesightService.FireForesightMergeIncidentsParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.secondaryIncidentId != null) __params = __params.set('secondaryIncidentId', params.secondaryIncidentId.toString());
    if (params.primaryIncidentId != null) __params = __params.set('primaryIncidentId', params.primaryIncidentId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/MergeIncidents`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightMergeIncidentsParams` containing the following parameters:
   *
   * - `secondaryIncidentId`:
   *
   * - `primaryIncidentId`:
   */
  FireForesightMergeIncidents(params: FireForesightService.FireForesightMergeIncidentsParams): __Observable<Blob> {
    return this.FireForesightMergeIncidentsResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param incident undefined
   */
  FireForesightUpdateIncidentResponse(incident: Incident): __Observable<__StrictHttpResponse<Incident>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = incident;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/UpdateIncident`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Incident>;
      })
    );
  }
  /**
   * @param incident undefined
   */
  FireForesightUpdateIncident(incident: Incident): __Observable<Incident> {
    return this.FireForesightUpdateIncidentResponse(incident).pipe(
      __map(_r => _r.body as Incident)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightSetInitialFireLocationParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `incidentId`:
   */
  FireForesightSetInitialFireLocationResponse(params: FireForesightService.FireForesightSetInitialFireLocationParams): __Observable<__StrictHttpResponse<Incident>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.longitude != null) { __formData.append('longitude', JSON.stringify(params.longitude));}
    if (params.latitude != null) { __formData.append('latitude', JSON.stringify(params.latitude));}
    if (params.incidentId != null) { __formData.append('incidentId', JSON.stringify(params.incidentId));}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/SetInitialFireLocation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Incident>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightSetInitialFireLocationParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `incidentId`:
   */
  FireForesightSetInitialFireLocation(params: FireForesightService.FireForesightSetInitialFireLocationParams): __Observable<Incident> {
    return this.FireForesightSetInitialFireLocationResponse(params).pipe(
      __map(_r => _r.body as Incident)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightAddNoteParams` containing the following parameters:
   *
   * - `notes`:
   *
   * - `incidentId`:
   */
  FireForesightAddNoteResponse(params: FireForesightService.FireForesightAddNoteParams): __Observable<__StrictHttpResponse<Note>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.notes != null) __params = __params.set('notes', params.notes.toString());
    if (params.incidentId != null) __params = __params.set('incidentId', params.incidentId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/AddNote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Note>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightAddNoteParams` containing the following parameters:
   *
   * - `notes`:
   *
   * - `incidentId`:
   */
  FireForesightAddNote(params: FireForesightService.FireForesightAddNoteParams): __Observable<Note> {
    return this.FireForesightAddNoteResponse(params).pipe(
      __map(_r => _r.body as Note)
    );
  }

  /**
   * @param noteId undefined
   */
  FireForesightRemoveNoteResponse(noteId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (noteId != null) __params = __params.set('noteId', noteId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/FireForesight/RemoveNote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param noteId undefined
   */
  FireForesightRemoveNote(noteId?: number): __Observable<Blob> {
    return this.FireForesightRemoveNoteResponse(noteId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customerId undefined
   */
  FireForesightGetMapLayersResponse(customerId?: null | number): __Observable<__StrictHttpResponse<Array<MapLayerItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireForesight/GetMapLayers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MapLayerItem>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  FireForesightGetMapLayers(customerId?: null | number): __Observable<Array<MapLayerItem>> {
    return this.FireForesightGetMapLayersResponse(customerId).pipe(
      __map(_r => _r.body as Array<MapLayerItem>)
    );
  }

  /**
   * @param params The `FireForesightService.FireForesightGetLastestFireSpreadModelParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `customerId`:
   */
  FireForesightGetLastestFireSpreadModelResponse(params: FireForesightService.FireForesightGetLastestFireSpreadModelParams): __Observable<__StrictHttpResponse<IncidentFireSpread>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireForesight/GetLastestFireSpreadModel/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.incidentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<IncidentFireSpread>;
      })
    );
  }
  /**
   * @param params The `FireForesightService.FireForesightGetLastestFireSpreadModelParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `customerId`:
   */
  FireForesightGetLastestFireSpreadModel(params: FireForesightService.FireForesightGetLastestFireSpreadModelParams): __Observable<IncidentFireSpread> {
    return this.FireForesightGetLastestFireSpreadModelResponse(params).pipe(
      __map(_r => _r.body as IncidentFireSpread)
    );
  }
}

module FireForesightService {

  /**
   * Parameters for FireForesightGetIncidentStatisticsByHour
   */
  export interface FireForesightGetIncidentStatisticsByHourParams {
    timeZoneId?: null | string;
    start?: string;
    end?: string;
    customerId?: number;
  }

  /**
   * Parameters for FireForesightGetCameraByUri
   */
  export interface FireForesightGetCameraByUriParams {
    siteUri: string;
    customerId: number;
  }

  /**
   * Parameters for FireForesightGetCamera
   */
  export interface FireForesightGetCameraParams {
    siteId: number;
    customerId: number;
  }

  /**
   * Parameters for FireForesightSetDaytimeImage
   */
  export interface FireForesightSetDaytimeImageParams {
    siteId: number;
    customerId: number;
    cameraBearing: number;
    url?: null | string;
  }

  /**
   * Parameters for FireForesightGetSites
   */
  export interface FireForesightGetSitesParams {
    pageSize?: number;
    page?: number;
  }

  /**
   * Parameters for FireForesightCreateSite
   */
  export interface FireForesightCreateSiteParams {
    YawError?: null | number;
    StorageBaseUrl?: null | string;
    SiteUri?: string;
    SiteId?: number;
    RollError?: null | number;
    PitchError?: null | number;
    PatrolSegments?: Array<PatrolSegment>;
    NextScheduledPatrol?: null | string;
    Name?: string;
    Longitude?: null | number;
    Latitude?: null | number;
    ImageWidth?: number;
    ImageHeight?: number;
    FieldOfView?: number;
    DemUrl?: null | string;
    CustomerId?: null | number;
    CameraHeight?: number;
    CameraElevation?: number;
    CameraAltitude?: number;
  }

  /**
   * Parameters for FireForesightUpdateSite
   */
  export interface FireForesightUpdateSiteParams {
    id: number;
    YawError?: null | number;
    StorageBaseUrl?: null | string;
    SiteUri?: string;
    SiteId?: number;
    RollError?: null | number;
    PitchError?: null | number;
    PatrolSegments?: Array<PatrolSegment>;
    NextScheduledPatrol?: null | string;
    Name?: string;
    Longitude?: null | number;
    Latitude?: null | number;
    ImageWidth?: number;
    ImageHeight?: number;
    FieldOfView?: number;
    DemUrl?: null | string;
    CustomerId?: null | number;
    CameraHeight?: number;
    CameraElevation?: number;
    CameraAltitude?: number;
  }

  /**
   * Parameters for FireForesightGetStreamKey
   */
  export interface FireForesightGetStreamKeyParams {
    siteId: number;
    customerId: number;
  }

  /**
   * Parameters for FireForesightAddStatus
   */
  export interface FireForesightAddStatusParams {
    Visible?: boolean;
    StatusId?: number;
    OrderBy?: number;
    IsActiveState?: boolean;
    DisplayName?: string;
    Description?: string;
    Colour?: string;
  }

  /**
   * Parameters for FireForesightUpdateStatus
   */
  export interface FireForesightUpdateStatusParams {
    Visible?: boolean;
    StatusId?: number;
    OrderBy?: number;
    IsActiveState?: boolean;
    DisplayName?: string;
    Description?: string;
    Colour?: string;
  }

  /**
   * Parameters for FireForesightAddResponsibleParty
   */
  export interface FireForesightAddResponsiblePartyParams {
    Visible?: boolean;
    ResponsiblePartyId?: number;
    OrderBy?: number;
    IsActive?: boolean;
    DistributionTemplateId?: null | number;
    DistributionListId?: null | number;
    DisplayName?: string;
    Description?: string;
    CustomerId?: null | number;
    Colour?: string;
  }

  /**
   * Parameters for FireForesightUpdateResponsibleParty
   */
  export interface FireForesightUpdateResponsiblePartyParams {
    Visible?: boolean;
    ResponsiblePartyId?: number;
    OrderBy?: number;
    IsActive?: boolean;
    DistributionTemplateId?: null | number;
    DistributionListId?: null | number;
    DisplayName?: string;
    Description?: string;
    CustomerId?: null | number;
    Colour?: string;
  }

  /**
   * Parameters for FireForesightGetIgnoreZones
   */
  export interface FireForesightGetIgnoreZonesParams {
    siteUri: string;
    customerId: number;
  }

  /**
   * Parameters for FireForesightCreateIgnoreZone
   */
  export interface FireForesightCreateIgnoreZoneParams {
    ZoomImageUrl?: null | string;
    Width?: number;
    SiteUri?: null | string;
    SiteName?: null | string;
    LowerElevation?: number;
    IsUnconfirmed?: boolean;
    IsNewIncident?: boolean;
    IncidentId?: number;
    ImageWidth?: number;
    ImageUrl?: null | string;
    ImageHeight?: number;
    ImageFeedUri?: null | string;
    Height?: number;
    FirstDetected?: string;
    FireDetectionId?: number;
    Elevation?: number;
    DetectionMetaData?: null | string;
    Confidence?: null | number;
    CameraFieldOfView?: number;
    CameraElevation?: number;
    CameraBearing?: number;
    Bearing?: number;
  }

  /**
   * Parameters for FireForesightUpdateIgnoreZone
   */
  export interface FireForesightUpdateIgnoreZoneParams {
    ZoomImageUrl?: null | string;
    Width?: number;
    SiteUri?: null | string;
    SiteName?: null | string;
    LowerElevation?: number;
    IsUnconfirmed?: boolean;
    IsNewIncident?: boolean;
    IncidentId?: number;
    ImageWidth?: number;
    ImageUrl?: null | string;
    ImageHeight?: number;
    ImageFeedUri?: null | string;
    Height?: number;
    FirstDetected?: string;
    FireDetectionId?: number;
    Elevation?: number;
    DetectionMetaData?: null | string;
    Confidence?: null | number;
    CameraFieldOfView?: number;
    CameraElevation?: number;
    CameraBearing?: number;
    Bearing?: number;
  }

  /**
   * Parameters for FireForesightRaiseManualDetection
   */
  export interface FireForesightRaiseManualDetectionParams {
    ZoomImageUrl?: null | string;
    Width?: number;
    SiteUri?: null | string;
    SiteName?: null | string;
    LowerElevation?: number;
    IsUnconfirmed?: boolean;
    IsNewIncident?: boolean;
    IncidentId?: number;
    ImageWidth?: number;
    ImageUrl?: null | string;
    ImageHeight?: number;
    ImageFeedUri?: null | string;
    Height?: number;
    FirstDetected?: string;
    FireDetectionId?: number;
    Elevation?: number;
    DetectionMetaData?: null | string;
    Confidence?: null | number;
    CameraFieldOfView?: number;
    CameraElevation?: number;
    CameraBearing?: number;
    Bearing?: number;
  }

  /**
   * Parameters for FireForesightGetIncidents
   */
  export interface FireForesightGetIncidentsParams {
    statusId: number;
    siteUri: string;
    customerId: number;
  }

  /**
   * Parameters for FireForesightGetIncident
   */
  export interface FireForesightGetIncidentParams {
    incidentId: number;
    customerId: number;
  }

  /**
   * Parameters for FireForesightMergeIncidents
   */
  export interface FireForesightMergeIncidentsParams {
    secondaryIncidentId?: number;
    primaryIncidentId?: number;
  }

  /**
   * Parameters for FireForesightSetInitialFireLocation
   */
  export interface FireForesightSetInitialFireLocationParams {
    longitude?: number;
    latitude?: number;
    incidentId?: number;
  }

  /**
   * Parameters for FireForesightAddNote
   */
  export interface FireForesightAddNoteParams {
    notes?: null | string;
    incidentId?: number;
  }

  /**
   * Parameters for FireForesightGetLastestFireSpreadModel
   */
  export interface FireForesightGetLastestFireSpreadModelParams {
    incidentId: number;
    customerId: number;
  }
}

export { FireForesightService }
